import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgStatement = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 60,
	height: 83,
	viewBox: "0 0 60 83",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsxs("g", {
			clipPath: "url(#clip0_647_118930)",
			children: [
				/* @__PURE__ */ _jsx("path", {
					d: "M27.8153 57.3067C27.1725 58.6606 27.3464 63.6382 27.7342 63.8207C28.1221 64.0036 32.0952 60.9793 32.7379 59.6249C33.3807 58.271 32.8 56.6543 31.4406 56.0141C30.0813 55.3739 28.4581 55.9523 27.8153 57.3062V57.3067Z",
					fill: "#BDD1F9"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M33.4172 63.8542C32.3051 64.8622 30.5623 69.5302 30.8513 69.8467C31.1403 70.1628 35.9701 68.8739 37.0823 67.8659C38.1944 66.8579 38.2754 65.1427 37.2634 64.035C36.2514 62.9274 34.5293 62.8466 33.4172 63.8546V63.8542Z",
					fill: "#BDD1F9"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M17.7369 37.5237C17.3361 38.8089 18.1203 43.2162 18.4887 43.3301C18.8571 43.4439 22.0099 40.2545 22.4107 38.9688C22.8116 37.6835 22.0901 36.3179 20.7997 35.9187C19.5092 35.5194 18.1381 36.238 17.7373 37.5237H17.7369Z",
					fill: "#7A98F0"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M21.1069 42.0165C20.7061 43.3018 21.4903 47.7091 21.8587 47.8229C22.2271 47.9367 25.3799 44.7473 25.7807 43.4616C26.1816 42.1763 25.4601 40.8107 24.1697 40.4111C22.8792 40.0119 21.5077 40.7304 21.1069 42.0161V42.0165Z",
					fill: "#7A98F0"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M26.92 47.1403C26.0579 48.177 25.0974 52.5495 25.3945 52.7945C25.6916 53.0392 29.8263 51.2864 30.6888 50.2502C31.5508 49.2136 31.4062 47.6776 30.3658 46.8186C29.325 45.96 27.7824 46.1037 26.9204 47.1403H26.92Z",
					fill: "#7A98F0"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M43.0161 69.0504C43.0161 69.0504 42.8897 55.1996 43.4315 54.0838C43.973 52.9685 46.1421 48.4344 46.4493 45.5397C46.7565 42.6454 45.5804 33.9087 45.2874 33.2225C44.9939 32.5363 45.6501 25.2508 45.1046 24.479C44.5583 23.7071 42.4126 24.2134 41.8464 27.8149C41.2799 31.4165 28.9525 46.2021 28.9525 46.2021L22.2304 48.7521C22.2304 48.7521 26.0964 53.6063 27.9819 55.9189L27.6292 68.6261L43.0161 69.0499V69.0504Z",
					fill: "#E3A491"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M22.6831 26.7189L22.7864 26.6132C23.6189 25.761 23.5998 24.3982 22.7443 23.5691L17.2943 18.2883C16.4092 17.4309 14.9943 17.4502 14.1331 18.3319C13.2722 19.2131 13.2917 20.6227 14.1768 21.4801L19.6268 26.7605C20.4824 27.5897 21.851 27.5707 22.6831 26.7185V26.7189Z",
					fill: "#E3A491"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M40.3489 12.1589L21.5576 11.6414C20.5079 11.6123 19.6333 12.4366 19.6045 13.4821L18.6585 47.5601C18.6294 48.606 19.457 49.4767 20.5067 49.5057L39.298 50.0233C40.3481 50.0523 41.2223 49.228 41.2515 48.1821L42.1974 14.1042C42.2266 13.0587 41.399 12.1875 40.3489 12.1585V12.1589Z",
					fill: "#F4F6F9"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M21.8186 11.9623C20.7956 11.9341 19.9405 12.7402 19.9121 13.7591L18.9807 47.3005C18.9524 48.3194 19.7617 49.1708 20.7847 49.199L39.0374 49.7016C40.0599 49.7298 40.9151 48.9241 40.9435 47.9052L41.8748 14.3638C41.9032 13.3449 41.0938 12.4932 40.0713 12.4649L21.8186 11.9623ZM39.02 50.3297L20.7673 49.8271C19.397 49.7896 18.3128 48.6484 18.3509 47.2836L19.2823 13.7421C19.3204 12.3773 20.4657 11.2975 21.836 11.3354L40.0887 11.838C41.459 11.8756 42.5427 13.0167 42.505 14.3815L41.5737 47.923C41.536 49.2878 40.3902 50.3672 39.02 50.3297Z",
					fill: "#050521"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M38.7988 40.3986C38.8083 40.0641 34.897 39.6818 30.0625 39.5448C25.228 39.4078 21.3012 39.5679 21.2916 39.9024C21.2821 40.2369 25.1934 40.6191 30.0279 40.7562C34.8624 40.8932 38.7892 40.7331 38.7988 40.3986Z",
					fill: "#84A7EC"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M35.0493 26.6157L34.9492 30.1188C34.9492 30.1188 33.217 29.6146 33.26 28.1174C33.3029 26.6198 35.0493 26.6161 35.0493 26.6161V26.6157Z",
					fill: "#6169F4"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M34.8609 30.0779C34.4669 29.6924 34.105 29.1027 34.1293 28.2453C34.1556 27.3253 34.6055 26.8611 35.0489 26.627L34.9492 30.1074C34.9492 30.1074 34.916 30.0977 34.8609 30.0775V30.0779Z",
					fill: "#FA7267"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M37.8301 33.6377C37.9212 30.4478 34.6176 27.7661 30.4512 27.648C26.2849 27.5299 22.8335 30.0201 22.7423 33.21C22.6512 36.3999 25.9548 39.0816 30.1212 39.1997C34.2876 39.3177 37.7389 36.8275 37.8301 33.6377Z",
					fill: "#6169F4"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M28.0213 28.7865C28.0213 28.7865 28.0239 28.7864 28.0249 28.7859C29.6139 28.3736 30.5136 28.554 30.5225 28.5558C30.5316 28.5576 30.5403 28.5519 30.5424 28.5429C30.5442 28.5338 30.5384 28.5251 30.5295 28.5231C30.5206 28.5213 29.6131 28.339 28.0166 28.7533C28.0076 28.7557 28.0021 28.7647 28.0045 28.7738C28.0065 28.7815 28.0135 28.7865 28.0213 28.7862L28.0213 28.7865Z",
					fill: "#060633"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M38.9284 35.6231L37.2918 35.5767L37.3858 32.2876L39.0224 32.334C39.097 32.336 39.1561 32.3982 39.1537 32.4725L39.0674 35.4919C39.0653 35.5662 39.0029 35.6247 38.9284 35.6227V35.6231Z",
					fill: "#6169F4"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M38.5223 33.8858C38.534 33.4797 38.6033 33.1523 38.6775 33.1543C38.7516 33.1563 38.8023 33.4873 38.7906 33.8934C38.7788 34.2995 38.7095 34.6269 38.6353 34.6249C38.5612 34.6229 38.5105 34.2919 38.5223 33.8858Z",
					fill: "#FA7267"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M35.3403 32.8787C35.348 32.6167 35.5673 32.41 35.8303 32.4177C36.0933 32.4254 36.3009 32.6437 36.2932 32.9057C36.2859 33.1677 36.0662 33.3744 35.8032 33.3667C35.5401 33.3595 35.3326 33.1407 35.3403 32.8787Z",
					fill: "#060633"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M33.061 26.6257L32.9609 30.1284C32.9609 30.1284 31.2286 29.6242 31.2716 28.127C31.3146 26.6294 33.061 26.6257 33.061 26.6257Z",
					fill: "#6169F4"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M32.8725 30.0877C32.4786 29.7022 32.1166 29.1124 32.1409 28.255C32.1673 27.3351 32.6172 26.8708 33.0606 26.6367L32.9608 30.1172C32.9608 30.1172 32.9276 30.1075 32.8721 30.0873L32.8725 30.0877Z",
					fill: "#FA7267"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M32.7647 39.9985L35.1339 40.0657L35.2013 37.706L32.8321 37.6388L32.7647 39.9985Z",
					fill: "#6169F4"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M25.14 39.7822L27.5092 39.8494L27.5766 37.4896L25.2074 37.4225L25.14 39.7822Z",
					fill: "#6169F4"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M22.0423 31.3111C22.0249 31.1153 22.1473 30.9094 22.3394 30.8105C22.476 30.7403 22.6442 30.7205 22.8136 30.7528C22.8091 30.7213 22.803 30.6906 22.7905 30.6628C22.737 30.5449 22.5899 30.5025 22.4391 30.4739L21.7234 30.3382C21.7088 30.3354 21.6994 30.3217 21.7023 30.3071C21.7051 30.2926 21.7189 30.2833 21.7335 30.2862L22.4492 30.4218C22.6142 30.4533 22.7759 30.5013 22.8391 30.641C22.8574 30.6809 22.8642 30.7245 22.8691 30.7653C22.8902 30.7706 22.9109 30.777 22.9319 30.7839C23.1123 30.844 23.2485 30.9514 23.3153 31.0866C23.3498 31.1561 23.3672 31.2336 23.3842 31.3091C23.4106 31.4265 23.4353 31.5375 23.52 31.6082C23.5314 31.6175 23.5326 31.6344 23.5233 31.6457C23.5139 31.657 23.4969 31.6582 23.4856 31.6489C23.3875 31.5666 23.3591 31.4419 23.332 31.3208C23.3157 31.2485 23.2991 31.1738 23.2675 31.1104C23.1856 30.9453 23.0114 30.8666 22.9149 30.8343C22.9015 30.8299 22.8882 30.8259 22.8752 30.8222C22.8918 30.9837 22.9068 31.1633 22.8561 31.3304C22.8055 31.4972 22.6644 31.6732 22.4642 31.6893C22.4525 31.6901 22.4411 31.6905 22.4294 31.6901C22.2397 31.6849 22.0602 31.5133 22.0423 31.3119V31.3111ZM22.3637 30.8573C22.1902 30.9466 22.0796 31.131 22.095 31.3062C22.1116 31.4927 22.2851 31.6498 22.4598 31.6356C22.634 31.6215 22.7609 31.4592 22.8051 31.3143C22.8549 31.1508 22.8371 30.9692 22.8201 30.8077C22.6563 30.7734 22.4942 30.7903 22.3637 30.8573Z",
					fill: "#6169F4"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M39.0471 50.0165L20.7677 49.5131C19.5737 49.4804 18.6326 48.4898 18.6654 47.3002L18.678 46.8452L41.2709 47.4673L41.258 47.9327C41.2251 49.1163 40.235 50.0492 39.0471 50.0165Z",
					fill: "#050521"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M24.2994 71.9999L26.0146 58.7522L44.324 59.2564L43.9831 70.5011L24.2994 71.9999Z",
					fill: "#4294D2"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M16.4359 28.1395L16.3354 28.2481C15.526 29.122 15.5816 30.484 16.459 31.2902L18.4531 33.122C19.3605 33.9556 20.775 33.8987 21.6119 32.9945C22.4488 32.0906 22.3917 30.6818 21.4838 29.8482L19.4898 28.0168C18.6123 27.2106 17.2449 27.266 16.4355 28.1399L16.4359 28.1395Z",
					fill: "#E3A491"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M15.5098 38.3843L15.4093 38.4925C14.6 39.3668 14.6555 40.7284 15.5329 41.5345L17.527 43.366C18.4344 44.1996 19.8489 44.1427 20.6858 43.2388C21.5227 42.335 21.4656 40.9262 20.5577 40.0926L18.5637 38.2612C17.6863 37.455 16.3188 37.5103 15.5094 38.3843H15.5098Z",
					fill: "#E3A491"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M15.3283 33.0022L15.2278 33.1108C14.4184 33.9847 14.4739 35.3467 15.3514 36.1529L17.7037 38.3133C18.6111 39.1465 20.0256 39.0896 20.8625 38.1857C21.6994 37.2819 21.6423 35.8735 20.7344 35.0395L18.3821 32.8791C17.5047 32.073 16.1372 32.1283 15.3279 33.0022H15.3283Z",
					fill: "#E3A491"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M37.3501 11.2398L25.0047 16.5125L27.0525 21.2691L39.398 15.9964L37.3501 11.2398Z",
					fill: "#BDD1F9"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M26.9553 21.5116L24.7622 16.4169L37.4474 11L39.6404 16.0947L26.9553 21.5116ZM25.2469 16.6098L27.149 21.0284L39.1553 15.9014L37.2533 11.4828L25.2469 16.6098Z",
					fill: "#91B5F8"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M34.2169 15.3458C33.7528 14.2676 32.4988 13.7683 31.4159 14.2305C30.3334 14.6927 29.832 15.9416 30.2961 17.0202C30.7601 18.0985 32.0141 18.5978 33.0966 18.1356C34.1792 17.6734 34.6805 16.4244 34.2164 15.3458H34.2169Z",
					fill: "#91B5F8"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M35.6366 14.8009C35.5304 14.5543 35.2435 14.44 34.9958 14.5458C34.7482 14.6516 34.6335 14.9374 34.7397 15.184C34.8459 15.4306 35.1328 15.5449 35.3804 15.4391C35.6281 15.3334 35.7428 15.0476 35.6366 14.8009Z",
					fill: "#91B5F8"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M29.6719 17.348C29.5657 17.1014 29.2788 16.9872 29.0312 17.0929C28.7835 17.1987 28.6688 17.4845 28.775 17.7311C28.8812 17.9778 29.1681 18.092 29.4158 17.9862C29.6634 17.8805 29.7781 17.5947 29.6719 17.348Z",
					fill: "#91B5F8"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M37.6335 23.1016L37.3315 23.7151L22.4184 24.3158L22.5226 23.7991L37.6335 23.1016Z",
					fill: "#4A78BC"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M37.158 17.2451L22.4511 17.9231L22.7144 23.5894L37.4213 22.9114L37.158 17.2451Z",
					fill: "#BBCFF8"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M22.5226 23.7992L22.2401 17.7304L37.351 17.0325L37.6335 23.1013L22.5226 23.7988V23.7992ZM22.6628 18.1143L22.908 23.3778L37.2107 22.7174L36.9655 17.4539L22.6628 18.1143Z",
					fill: "#7896F6"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M32.3566 20.2546C32.297 18.9702 31.2027 17.9771 29.9131 18.0365C28.6234 18.0962 27.6264 19.1857 27.686 20.4702C27.7456 21.7547 28.8399 22.7477 30.1295 22.6884C31.4191 22.6286 32.4161 21.5391 32.3566 20.2546Z",
					fill: "#7896F6"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M34.0239 20.2397C34.0101 19.9458 33.7601 19.7186 33.465 19.7323C33.17 19.746 32.9418 19.9951 32.9556 20.2889C32.9694 20.5828 33.2194 20.8097 33.5145 20.7964C33.8095 20.7826 34.0377 20.5336 34.0239 20.2397Z",
					fill: "#7896F6"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M26.9192 20.5678C26.9054 20.2739 26.6553 20.0471 26.3603 20.0604C26.0652 20.0741 25.8375 20.3232 25.8508 20.617C25.8646 20.9109 26.1147 21.1378 26.4097 21.1245C26.7048 21.1107 26.933 20.8617 26.9192 20.5678Z",
					fill: "#7896F6"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M22.4184 24.316L22.5226 23.7993L22.2401 17.7305L22.1165 18.6359L22.4184 24.316Z",
					fill: "#4A78BC"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M37.5057 23.3341L35.5017 23.4363L35.5043 23.4863L37.5083 23.3841L37.5057 23.3341Z",
					fill: "#7896F6"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M37.4031 23.516L36.2285 23.5759L36.2311 23.6259L37.4057 23.566L37.4031 23.516Z",
					fill: "#7896F6"
				})
			]
		}),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
			id: "clip0_647_118930",
			children: /* @__PURE__ */ _jsx("rect", {
				width: 33,
				height: 61,
				fill: "white",
				transform: "translate(13.5 11)"
			})
		}) })
	]
});
const ForwardRef = forwardRef(SvgStatement);
export { ForwardRef as ReactComponent };
